module.exports = __webpack_public_path__ + "img/waymidia.1bfba2db.jpeg";